import classNames from 'classnames';
import { forwardRef } from 'react';
const labelCss = "l1bllxiw";
export const Label = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(labelCss, props.className)} />;
});

require("./label.wyw-in-js.css!=!../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./label.js");